import type en from './en';

type Messages = Record<keyof typeof en, string>;

const hi: Messages = {
  'board.return.context': 'दूसरे काम में मदद',
  'board.return.helping': 'यह काम {owner} की मदद कर रहा है: {title}',
  'board.return.action': 'मेरा हिस्सा पूरा है — अनुरोधकर्ता को लौटाएँ',
  'board.return.guidance': 'यह सहायक काम आपके बोर्ड से, पूर्ण कॉलम से भी, हटा देता है और उसका इतिहास सुरक्षित रखता है। आपका संदेश अनुरोधकर्ता के मूल काम में जाता है। सभी सहायक काम पूरे होने और बाहरी प्रतीक्षा खत्म होने पर उनका काम जारी कॉलम में लौटता है।',
  'board.return.messageRequired': 'लौटाने से पहले नीचे “क्या बदला है?” में आवश्यक संदेश लिखें।',
  'board.return.confirm': 'यह सहायक काम अपने बोर्ड से हटाकर संदेश {owner} को लौटाएँ: {title}? इतिहास सुरक्षित रहेगा। अनुरोधकर्ता का मूल काम पूरा चिह्नित नहीं होगा।',
  'board.return.blockers': 'अनसुलझी निर्भरताएँ',
  'board.return.resolveFirst': 'इस काम को पूरा करने, लौटाने या हटाने से पहले ये निर्भरताएँ सुलझाएँ।',
  'board.return.parentSelected': 'इस व्यक्ति ने आपकी मदद माँगी थी। उन्हें वापस सहायक काम न सौंपें। अपना हिस्सा पूरा होने पर “मेरा हिस्सा पूरा है — अनुरोधकर्ता को लौटाएँ” चुनें।',
  'myDay.heading': 'मेरा दिन',
  'myDay.welcome': 'हाज़िरी लगाएँ, एक कदम बढ़ाएँ और टीम को जानकारी दें।',
  'myDay.title': 'काम को आगे बढ़ाएँ',
  'myDay.hint': 'पहले नियत काम, फिर पहले से चल रहे काम।',
  'myDay.next': 'अगला काम देखें',
  'myDay.completed': 'आज {n} काम पूरे हुए',
  'myDay.open': 'आपके बोर्ड पर {n} काम बाकी हैं',
  'myDay.progressHint': 'पूरे हुए काम आज की IST तारीख के हैं। बाकी काम पूरी सूची है, दैनिक लक्ष्य नहीं।',
  'myDay.emptyHint': 'थोड़ी राहत। तैयार होने पर नया काम जोड़ें।',
  'myDay.loadError': 'काम लोड नहीं हो सके। आपकी हाज़िरी पर कोई असर नहीं है।',
  'myDay.start': 'काम शुरू करें',
  'myDay.update': 'त्वरित अपडेट',
  'myDay.finish': 'पूरा चिह्नित करें',
  'myDay.help': 'प्रतीक्षा / मदद चाहिए',
  'myDay.showAll': 'सभी {n} बाकी काम देखें',
  'myDay.showLess': 'कम काम दिखाएँ',
  'myDay.add': 'और क्या करना है?',
  'myDay.reviewTitle': 'पंच आउट हो गया। एक छोटी समीक्षा?',
  'myDay.reviewHint': 'केवल पूरे हुए काम चुनें। बाकी काम अपनी मौजूदा स्थिति और नियत तारीख के साथ अगले दिन के लिए खुले रहेंगे।',
  'myDay.planHint': 'शुरू करने के लिए काम चुनें या चल रहे काम जारी रखें। बिना चुने काम नहीं बदलेंगे — कोई काम पूरा नहीं चिह्नित होगा।',
  'myDay.later': 'यह बाद में करूँगा/करूँगी',
  'myDay.carryForward': 'सभी बाकी काम खुले रखें',
  'myDay.completeSelected': 'चुने काम पूरे करें ({n})',
  'board.seen': 'देखा गया {date}',
  'board.delivered': 'पहुँचाया गया',
  'board.due.label': 'समय सीमा',
  'board.due.optional': 'अंतिम तारीख (वैकल्पिक)',
  'board.due.overdue': 'समय सीमा बीत गई',
  'board.due.today': 'आज तक',
  'board.date.today': 'आज',
  'board.date.tomorrow': 'कल',
  'board.date.friday': 'इस शुक्रवार',
  'board.date.monday': 'अगले सोमवार',
  'board.updates.title': 'कार्ड अपडेट',
  'board.updates.prompt': 'क्या बदलाव हुआ है?',
  'board.updates.waitingOn': 'किसका इंतज़ार है (वैकल्पिक)',
  'board.updates.nextFollowup': 'अगली अनुवर्ती तारीख (वैकल्पिक)',
  'board.updates.timeline': 'अपडेट का इतिहास',
  'board.updates.add': 'अपडेट जोड़ें',
  'board.updates.empty': 'अभी कोई अपडेट नहीं है।',
  'board.updates.unavailable': 'यह कार्ड उपलब्ध नहीं है या आपकी पहुँच नहीं है।',
  'board.updates.status': 'स्थिति',
  'board.status.on_track': 'सही दिशा में',
  'board.status.waiting': 'इंतज़ार में',
  'board.status.blocked': 'अटका हुआ',
  'board.status.done': 'पूरा',
  'board.reminders.title': 'Omar से',
  'board.reminders.nudged': 'अपडेट माँगा गया है।',
  'board.reminders.empty': 'अभी किसी काम की प्रगति जानकारी ज़रूरी नहीं है।',
  'board.reminders.dismiss': 'आज के लिए बंद करें',
  'board.quick.start': 'काम जारी है',
  'board.quick.done': 'पूरा',
  'board.quick.text.on_track': 'इस पर काम जारी है।',
  'board.quick.text.waiting': 'जवाब का इंतज़ार है।',
  'board.quick.text.blocked': 'रुकावट: ',
  'board.quick.text.done': 'यह काम पूरा हो गया।',
  'board.create.step': '3 में से चरण {n}',
  'board.create.guidance': 'एक स्पष्ट काम लिखें जिसे आप पूरा कर सकते हैं।',
  'board.create.back': 'पीछे',
  'board.create.next': 'आगे',
  'board.create.keepStatus': 'चुना हुआ कॉलम रखें',
  'common.loading': 'लोड हो रहा है...',
  'common.cancel': 'रद्द करें',
  'common.save': 'सहेजें',
  'common.saving': 'सहेजा जा रहा है...',
  'common.submit': 'जमा करें',
  'common.submitting': 'जमा हो रहा है...',
  'common.retry': 'फिर कोशिश करें',
  'common.edit': 'संपादित करें',
  'common.delete': 'हटाएँ',
  'common.close': 'बंद करें',
  'common.location': 'स्थान',

  'a11y.rowActions': 'पंक्ति क्रियाएँ',

  'pagination.total': '{count} कुल',
  'pagination.pageOf': 'पृष्ठ {page} / {total}',
  'pagination.previous': 'पिछला',
  'pagination.next': 'अगला',

  'unit.hours': 'घं',
  'unit.days': 'दि',

  'lang.label': 'भाषा',
  'lang.english': 'English',
  'lang.kannada': 'ಕನ್ನಡ',
  'lang.odia': 'ଓଡ଼ିଆ',
  'lang.hindi': 'हिन्दी',

  'login.brand.eyebrow': 'समय और उपस्थिति',
  'login.brand.title': 'पंच इन करें,\nट्रैक पर रहें।',
  'login.brand.subtitle': 'घंटे, कार्य और छुट्टी एक ही जगह से ट्रैक करें।',
  'login.brand.footer': 'केवल स्टाफ़ पहुँच।',
  'login.signIn': 'साइन इन',
  'login.signInHint': 'अपना कार्य ईमेल और पासवर्ड दर्ज करें।',
  'login.email': 'ईमेल',
  'login.password': 'पासवर्ड',
  'login.passwordPlaceholder': 'पासवर्ड दर्ज करें',
  'login.signingIn': 'साइन इन हो रहा है...',
  'login.emailPasswordRequired': 'ईमेल और पासवर्ड आवश्यक हैं',
  'login.togglePassword': 'पासवर्ड दृश्यता बदलें',
  'login.mfa.title': 'दो-चरण सत्यापन',
  'login.mfa.hint': 'अपने authenticator ऐप से 6-अंकीय कोड दर्ज करें।',
  'login.mfa.code': 'सत्यापन कोड',
  'login.mfa.verify': 'सत्यापित करें',
  'login.mfa.verifying': 'सत्यापित हो रहा है...',
  'login.mfa.codeRequired': 'authenticator ऐप से 6-अंकीय कोड दर्ज करें',
  'login.setup.title': 'दो-चरण सत्यापन सेट करें',
  'login.setup.hint': 'HR और admin खातों के लिए दो-चरण सत्यापन आवश्यक है। लगभग एक मिनट।',
  'login.setup.scanHint':
    'Google Authenticator, Microsoft Authenticator, या 1Password जैसे authenticator ऐप से यह QR कोड स्कैन करें।',
  'login.setup.qrAlt': 'Authenticator QR कोड',
  'login.setup.manualSummary': 'स्कैन नहीं हो रहा? कुंजी मैन्युअल दर्ज करें',
  'login.setup.manualHint': 'अपने authenticator ऐप में यह कुंजी दर्ज करें:',
  'login.setup.codeLabel': 'ऐप से 6-अंकीय कोड दर्ज करें',
  'login.setup.enabling': 'सक्षम हो रहा है...',
  'login.setup.enable': 'दो-चरण सत्यापन चालू करें',
  'login.setup.codeRequired': 'authenticator ऐप में दिखाया 6-अंकीय कोड दर्ज करें',

  'app.loading': 'लोड हो रहा है...',

  'footer.text': 'Teams · बिल्ड {version}',

  'nav.self': 'व्यक्तिगत',
  'nav.today': 'आज',
  'nav.myRequests': 'मेरे अनुरोध',
  'nav.board': 'बोर्ड',
  'nav.teamBoard': 'टीम बोर्ड',
  'nav.history': 'इतिहास',
  'nav.holidays': 'छुट्टियाँ',
  'nav.handbook': 'हैंडबुक',
  'nav.announcements': 'घोषणाएँ',

  'meta.today.title': 'आज',
  'meta.today.subtitle': 'पंच इन/आउट और आपका दिन कैसा दिखता है',
  'meta.today.exemptSubtitle': 'Your tasks, leave, and updates for today',
  'meta.board.title': 'बोर्ड',
  'meta.board.subtitle': 'आपका व्यक्तिगत to-do बोर्ड — कार्ड कॉलम के बीच खींचें',
  'meta.teamBoard.title': 'टीम बोर्ड',
  'meta.teamBoard.subtitle': 'सभी के कार्ड — स्थानांतरित, संपादित और हटाएँ',
  'meta.my_requests.title': 'मेरे अनुरोध',
  'meta.my_requests.subtitle': 'आपके द्वारा दर्ज छुट्टी, देर और जल्दी छुट्टी',
  'meta.history.title': 'इतिहास',
  'meta.history.subtitle': 'आपका पंच इतिहास',
  'meta.handbook.title': 'हैंडबुक',
  'meta.handbook.subtitle': 'घोषणाएँ, नियम, HR नीति और छुट्टियाँ',

  'role.employee': 'कर्मचारी',
  'role.hr': 'HR',
  'role.admin': 'Admin',
  'shell.logout': 'लॉग आउट',
  'shell.openNav': 'नेविगेशन खोलें',
  'shell.closeNav': 'नेविगेशन बंद करें',
  'shell.themeLight': 'लाइट थीम पर स्विच करें',
  'shell.themeDark': 'डार्क थीम पर स्विच करें',
  'shell.primaryNav': 'मुख्य नेविगेशन',
  'shell.more': 'अधिक',
  'shell.moreHint': 'आपके उपलब्ध पृष्ठ और खाता नियंत्रण।',
  'shell.accountControls': 'खाता नियंत्रण',
  'shell.muteSounds': 'ध्वनि बंद करें',
  'shell.enableSounds': 'ध्वनि चालू करें',

  'notify.title': 'सूचनाएँ',
  'notify.markAllRead': 'सभी पढ़ा हुआ चिह्नित करें',
  'notify.enablePush': 'पुश सूचनाएँ सक्षम करें',
  'notify.enabling': 'सक्षम हो रहा है...',
  'notify.empty': 'अभी कोई सूचना नहीं।',
  'notify.justNow': 'अभी',
  'notify.minutesAgo': '{n} मि. पहले',
  'notify.hoursAgo': '{n} घं. पहले',
  'notify.daysAgo': '{n} दि. पहले',
  'notify.pushEnabled': 'पुश सूचनाएँ सक्षम हो गईं।',
  'notify.pushFailed': 'पुश सूचनाएँ सक्षम नहीं हो सकीं।',

  'dashboard.loading': 'डैशबोर्ड लोड हो रहा है...',
  'dashboard.error': 'डैशबोर्ड लोड नहीं हो सका।',
  'dashboard.onLeave': 'छुट्टी पर',
  'dashboard.onClock': 'क्लॉक पर',
  'dashboard.offClock': 'क्लॉक से बाहर',
  'dashboard.attendanceExempt': 'Attendance exempt',
  'dashboard.attendanceNotRequired': 'No punch-in required',
  'dashboard.attendanceExemptHint': 'Your account is not part of attendance tracking.',
  'dashboard.onLeaveToday': 'आप आज स्वीकृत छुट्टी पर हैं',
  'dashboard.onLeaveDisabled': 'छुट्टी पर होने पर पंच इन अक्षम है।',
  'dashboard.inSince': '{time} से अंदर',
  'dashboard.soFar': 'अब तक',
  'dashboard.notPunchedIn': 'पंच इन नहीं',
  'dashboard.punchInHint': 'काम शुरू करते समय पंच इन करें।',
  'dashboard.punchIn': 'पंच इन',
  'dashboard.punchOut': 'पंच आउट',
  'dashboard.stat.today': 'आज',
  'dashboard.stat.week': 'इस सप्ताह',
  'dashboard.stat.leaveLeft': 'बची छुट्टी',
  'dashboard.stat.openCards': 'खुले कार्ड',
  'dashboard.myTasks': 'मेरे कार्य',
  'dashboard.myTasksHint': 'आपके व्यक्तिगत बोर्ड पर खुले कार्ड।',
  'dashboard.viewBoard': 'बोर्ड खोलें',
  'dashboard.noOpenTasks': 'कोई खुला कार्य नहीं — आपका बोर्ड साफ़ है।',
  'dashboard.leave': 'छुट्टी',
  'dashboard.leaveThrough': '{date} तक छुट्टी पर',
  'dashboard.days': 'दिन',
  'dashboard.upcomingLeave': 'आगामी छुट्टी: {start} – {end}.',
  'dashboard.noLeaveScheduled': 'कोई स्वीकृत छुट्टी निर्धारित नहीं।',
  'dashboard.pendingRequests': '{n} अनुरोध स्वीकृति के लिए लंबित।',
  'dashboard.yourLeave': 'आपकी छुट्टी',
  'dashboard.noLeaveTypes': 'अभी कोई छुट्टी प्रकार कॉन्फ़िगर नहीं।',
  'dashboard.announcements': 'घोषणाएँ',
  'dashboard.noAnnouncements': 'अभी कोई घोषणा नहीं।',
  'dashboard.toast.punchedInZone': '{zone} में पंच इन।',
  'dashboard.toast.punchedIn': 'आप पंच इन हैं।',
  'dashboard.toast.punchedInLate': 'आप {minutes} मिनट देर से आए हैं।',
  'dashboard.toast.punchedOut': 'आप पंच आउट हैं।',

  'punch.board.emptyTitle': 'आज आप क्या काम कर रहे हैं?',
  'punch.board.emptyHint': 'आज के लिए एक कार्य जोड़ें, या दर्ज करें कि आपके पास कोई नियत काम नहीं है।',
  'punch.board.pickWorkTitle': 'आज आप क्या काम कर रहे हैं?',
  'punch.board.pickWorkHint': 'नीचे आज की योजना बनाएं। चेक किया गया कार्य चुना गया है; हटाने के लिए दोबारा टैप करें।',
  'punch.board.groupOngoing': 'चल रहा',
  'punch.board.groupAvailable': 'उपलब्ध',
  'punch.board.groupBlocked': 'अवरुद्ध — ध्यान आवश्यक',
  'punch.board.blockedHint': 'ये जानकारी के लिए दिखाए गए हैं। इन्हें फिर शुरू करने से पहले बोर्ड पर रुकावट हल करें।',
  'punch.board.todayPlan': 'आज की योजना',
  'punch.board.selectedCount': '{n} चुने गए',
  'punch.board.selected': 'चुना गया',
  'punch.board.notSelected': 'नहीं चुना',
  'punch.board.continueToday': 'आज जारी रखें',
  'punch.board.willMarkDone': 'आज की योजना में नहीं — पूर्ण माना जाएगा',
  'punch.board.startToday': 'आज शुरू करें',
  'punch.board.staysTodo': 'करना है में रहेगा',
  'punch.board.confirmSelected': '{n} कार्यों के साथ दिन शुरू करें',
  'punch.board.confirmNone': 'जारी कार्यों को पूर्ण चिह्नित करें',
  'punch.board.selectTask': 'कम से कम एक कार्य चुनें',
  'punch.board.blockedOnlyHint': 'आपके नियत कार्य अवरुद्ध हैं। ध्यान देने वाली चीज़ें देखें, फिर आज का दूसरा काम जोड़ें या कोई उपलब्ध काम न होने का रिकॉर्ड करें।',
  'punch.board.doingDoneTitle': 'क्या ये पूरे हो गए?',
  'punch.board.doingDoneHint': 'जो कार्य पूरे हो गए हों उन्हें चुनें।',
  'punch.board.pickTodoTitle': 'आप क्या करेंगे?',
  'punch.board.pickTodoHint': 'doing में ले जाने के लिए कार्य चुनें।',
  'punch.board.skip': 'छोड़ें',
  'punch.board.confirm': 'पुष्टि करें',
  'punch.board.toast.markedDone': 'पूर्ण के रूप में चिह्नित।',
  'punch.board.toast.started': 'doing में ले जाया गया।',
  'punch.board.toast.confirmed': 'कार्य अपडेट किया गया।',

  'punchIn.title': 'पंच इन',
  'punchIn.home.title': 'कृपया घर या ऑफिस से पंच इन करें।',
  'punchIn.home.hint': 'ऑफिस में होने पर Office दिखेगा। बाकी जगह Home।',
  'punchIn.untagged': 'Sales पंच — roster में Sales दिखेगा। GPS स्थान आवश्यक है और दर्ज किया जाता है; geofence लागू नहीं है।',
  'punchIn.gettingLocation': 'आपका स्थान प्राप्त हो रहा है...',
  'punchIn.atSite': '{name} पर',
  'punchIn.locationCaptured': 'स्थान कैप्चर ({lat}, {lng})',
  'punchIn.refreshLocation': 'Refresh location',
  'punchIn.outsideSiteHint': 'Outside {name} radius: {distance} m away (radius {radius} m). Refresh location, check this site\'s location permission, or ask HR for help.',
  'punchIn.geoUnsupported': 'यह ब्राउज़र geolocation समर्थित नहीं करता।',
  'punchIn.geoDenied': 'स्थान पहुँच अस्वीकार। कृपया स्थान अनुमति दें और फिर कोशिश करें।',
  'punchIn.geoError': 'आपका स्थान निर्धारित नहीं हो सका ({msg})।',
  'punchIn.you': 'आप',
  'punchIn.kmTo': '— {name} से {km} km',
  'punchIn.placeDetails': 'स्थान की जानकारी (वैकल्पिक)',
  'punchIn.lookingUp': 'स्थान खोजा जा रहा है — आप अभी पंच कर सकते हैं।',
  'punchIn.placeName': 'स्थान का नाम (वैकल्पिक)',
  'punchIn.area': 'क्षेत्र (वैकल्पिक)',
  'punchIn.nameHint': 'आपकी GPS लोकेशन ही काफी है। चाहें तो स्थान की जानकारी भरें या सुधारें, या खाली छोड़ दें। होटल या Maps लिंक की ज़रूरत नहीं है।',
  'punchIn.punchingIn': 'पंच इन हो रहा है...',
  'punchIn.fallbackHome': 'घर',
  'punchIn.fallbackField': 'क्षेत्र',

  'punchOut.title': 'पंच आउट',
  'punchOut.home.title': 'कृपया घर या ऑफिस से पंच आउट करें।',
  'punchOut.untagged': 'क्लॉक आउट। Sales पंच के लिए GPS स्थान आवश्यक है और दर्ज किया जाता है।',
  'punchOut.punchingOut': 'पंच आउट हो रहा है...',

  'requests.new': 'नया अनुरोध',
  'requests.error': 'अनुरोध लोड नहीं हो सके।',
  'requests.empty': 'अभी कोई अनुरोध नहीं',
  'requests.edit': 'अनुरोध संपादित करें',
  'requests.fullRequest': 'पूरा अनुरोध',
  'requests.type': 'प्रकार',
  'requests.type.leave': 'छुट्टी',
  'requests.type.late': 'देर',
  'requests.type.early_leaving': 'जल्दी छुट्टी',
  'requests.type.other': 'अन्य',
  'requests.startDate': 'प्रारंभ तिथि',
  'requests.endDate': 'समाप्ति तिथि',
  'requests.halfDay': 'आधा दिन',
  'requests.leaveType': 'छुट्टी प्रकार',
  'requests.selectLeaveType': 'छुट्टी प्रकार चुनें...',
  'requests.leaveTypeLabel': '{name} — {remaining} में से {quota} बचे',
  'requests.reasonCategory': 'कारण श्रेणी',
  'requests.selectCategory': 'श्रेणी चुनें...',
  'requests.reason': 'कारण',
  'requests.date': 'तिथि(याँ)',
  'requests.status': 'स्थिति',
  'requests.businessDays': '≈ {n} कार्य दिन।',
  'requests.lateHint': 'ट्रैकिंग के लिए दर्ज, स्वीकृति आवश्यक नहीं।',
  'requests.error.datesRequired': 'प्रारंभ और समाप्ति तिथि आवश्यक।',
  'requests.error.leaveTypeRequired': 'छुट्टी प्रकार आवश्यक।',
  'requests.error.dateRequired': 'तिथि आवश्यक।',
  'requests.error.reasonRequired': 'कारण आवश्यक।',
  'requests.toast.updated': 'अनुरोध अपडेट हुआ।',
  'requests.toast.submitted': 'अनुरोध जमा हुआ।',
  'requests.toast.deleted': 'अनुरोध हटाया गया।',
  'requests.confirmDelete': 'यह अनुरोध हटाएँ?',
  'requests.status.pending': 'लंबित',
  'requests.status.approved': 'स्वीकृत',
  'requests.status.rejected': 'अस्वीकृत',
  'requests.status.logged': 'दर्ज',
  'requests.category.sick': 'बीमारी',
  'requests.category.personal': 'व्यक्तिगत',
  'requests.category.vacation': 'अवकाश',
  'requests.category.family': 'परिवार',
  'requests.category.bereavement': 'शोक',
  'requests.category.menstrual': 'मासिक धर्म',
  'requests.category.other': 'अन्य',

  'board.noWorkToday': 'आज मेरे लिए कोई काम नहीं है',
  'board.loggedToday': 'आज दर्ज',
  'board.loggedTodayTitle': 'आपने आज पहले ही दर्ज कर लिया है।',
  'board.error': 'आपका बोर्ड लोड नहीं हो सका।',
  'board.emptyBoard': 'अभी कोई कार्ड नहीं — शुरू करने के लिए एक जोड़ें।',
  'board.column.todo': 'करना है',
  'board.column.doing': 'कर रहे हैं',
  'board.column.blocked': 'अवरुद्ध',
  'board.column.done': 'पूर्ण',
  'board.columnAria': 'बोर्ड कॉलम',
  'board.addCard': 'कार्ड जोड़ें',
  'board.addCardTo': '{col} में कार्ड जोड़ें',
  'board.editCard': 'कार्ड संपादित करें',
  'board.newCard': 'नया कार्ड — {col}',
  'board.title': 'शीर्षक',
  'board.description': 'विवरण',
  'board.error.titleRequired': 'शीर्षक आवश्यक।',
  'board.toast.updated': 'कार्ड अपडेट हुआ।',
  'board.toast.created': 'कार्ड बनाया गया।',
  'board.toast.deleted': 'कार्ड हटाया गया।',
  'board.toast.moved': '{col} में स्थानांतरित।',
  'board.toast.logged': 'दर्ज हुआ।',
  'board.confirmDelete': '"{title}" हटाएँ?',
  'board.moveTo': '{col} में ले जाएँ',
  'board.deleteCard': 'कार्ड हटाएँ',
  'board.doneAt': 'पूर्ण {date}',
  'board.fromLabel': '{label} से',
  'board.myTask': 'आपका काम',
  'board.source.commandCentre': 'Command Centre',
  'board.source.chiefOfStaff': 'Omar',
  'board.sharedProgress': 'Shared: {completed}/{total}', 'board.blockedReason': 'Blocked: {reason}', 'board.blockedExternal': 'Waiting on {name}', 'board.helpers': 'Helpers: {helpers}', 'board.blocking': 'Blocking {user}: {title}', 'board.toast.blocked': 'Task blocked and helpers notified.',
  'board.block.title': 'Block task', 'board.block.intro': 'Add helper tasks needed to unblock “{title}”.', 'board.block.reason': 'What is blocked?', 'board.block.modeLabel': 'Blocking type', 'board.block.modeHelpers': 'Hand over to teammate', 'board.block.modeExternal': 'External party', 'board.block.externalName': 'External party name', 'board.block.externalNamePlaceholder': 'e.g. Shafiq sir, vendor name', 'board.block.externalGuidance': 'Use this only when nobody inside the company can unblock it. Name the person or party and describe what is awaited above.', 'board.block.missingInfoCta': 'Add blocking info: name a teammate or external party.', 'board.block.setInfo': 'Set blocking info', 'board.block.firstNameGuidance': 'Enter the helper’s exact full first name. If more than one person has that name, select the right person below.', 'board.block.helperNumber': 'Helper {n}', 'board.block.helperFirstName': 'Helper first name', 'board.block.helperPerson': 'Helper', 'board.block.helperPersonPlaceholder': 'Select a teammate', 'board.block.selectedHelper': 'Selected: {name}', 'board.block.matches': 'Matching helpers', 'board.block.helperTask': 'Helper task', 'board.block.removeHelper': 'Remove helper', 'board.block.addHelper': 'Add another helper', 'board.block.submit': 'Block task',

  'teamBoard.readOnly': 'केवल पढ़ने योग्य टीम दृश्य',
  'teamBoard.filterAll': 'सभी',
  'teamBoard.filterPeople': 'व्यक्ति से फ़िल्टर करें',
  'teamBoard.people': 'लोग',
  'teamBoard.peopleSelected': '{n} लोग',
  'teamBoard.selectPeople': 'लोग चुनें',
  'teamBoard.error': 'टीम बोर्ड लोड नहीं हो सका।',
  'teamBoard.emptyColumn': 'कोई कार्ड नहीं',
  'teamBoard.newCardFor': '{person} के लिए नया कार्ड — {col}',
  'teamBoard.composerLabel': 'कार्य सौंपें',
  'teamBoard.composerPlaceholder': 'Type @ to add people', 'teamBoard.composerTaskPlaceholder': 'Task for selected people', 'teamBoard.removeRecipient': 'Remove {name}',
  'teamBoard.composerInvalid': 'सुझावों से व्यक्ति चुनें और कार्य दर्ज करें।',
  'teamBoard.assign': 'सौंपें',
  'teamBoard.searchCards': 'कार्ड या व्यक्ति खोजें',
  'teamBoard.searchPeople': 'लोग खोजें',
  'teamBoard.noPeopleMatch': 'कोई व्यक्ति नहीं मिला।',
  'teamBoard.summary': '{total} में से {shown} कार्ड दिखाए जा रहे हैं',
  'teamBoard.emptyBoard': 'अभी कोई टीम कार्ड नहीं है।',
  'teamBoard.emptySearch': 'आपकी खोज से कोई कार्ड नहीं मिला।',
  'teamBoard.clearFilters': 'फ़िल्टर हटाएँ',
  'teamBoard.attention': 'Attention',
  'teamBoard.attentionTitle': 'Needs attention',
  'teamBoard.attentionEmpty': 'Nothing blocked, nothing stale. Every board is moving.',
  'teamBoard.attentionBlocked': 'Blocked ({n})',
  'teamBoard.attentionStale': 'Stuck in Doing 3+ days ({n})',
  'teamBoard.attentionStaleAge': '{age} in Doing',
  'teamBoard.ageDays': '{n}d',
  'teamBoard.usage': 'Usage',
  'teamBoard.usageTitle': 'Board usage',
  'teamBoard.usageName': 'Name',
  'teamBoard.usageLastOpened': 'Last opened',
  'teamBoard.usageOpens': 'Opens',
  'teamBoard.usageNever': 'Never',
  'teamBoard.usageAgo': '{n}d ago',
  'fieldAttention.subtitle': 'Blocked chains and work sitting in Doing across your field team.',
  'fieldAttention.error': 'Could not load the field board.',
  'teamBoard.activity': 'गतिविधि',
  'teamBoard.activityTitle': 'बोर्ड गतिविधि',
  'teamBoard.activityLoading': 'गतिविधि लोड हो रही है...',
  'teamBoard.activityEmpty': 'अभी कोई गतिविधि नहीं।',
  'teamBoard.activitySystem': 'सिस्टम',

  'noWork.title': 'आज कोई काम नहीं?',
  'noWork.intro':
    'आज कोई नियत काम नहीं? इसके बजाय जो उठाया उसे दर्ज करें — housekeeping, अपना कार्ड, या मदद की छोटी टिप्पणी।',
  'noWork.kind.housekeeping': 'Housekeeping',
  'noWork.kind.ownCard': 'मेरे कार्ड में से एक',
  'noWork.kind.note': 'छोटी टिप्पणी',
  'noWork.housekeepingItem': 'Housekeeping आइटम',
  'noWork.noHousekeeping': 'Housekeeping आइटम अभी कॉन्फ़िगर नहीं — दूसरा विकल्प चुनें।',
  'noWork.choose': '— चुनें —',
  'noWork.yourCard': 'आपका कार्ड',
  'noWork.noCards': 'कोई खुला to-do या blocked कार्ड नहीं — दूसरा विकल्प चुनें।',
  'noWork.note': 'टिप्पणी',
  'noWork.notePlaceholder': 'उदा. Ravi को site survey में मदद की',
  'noWork.error.pickOne': 'नीचे तीन विकल्पों में से एक चुनें।',
  'noWork.logIt': 'दर्ज करें',
  'noWork.recent': 'हाल का',
  'noWork.describe.ownCard': 'मेरे कार्ड में से एक',
  'noWork.describe.housekeeping': 'housekeeping',

  'history.error': 'कार्य लॉग लोड नहीं हो सके।',
  'history.empty': 'अभी कोई कार्य लॉग नहीं',
  'history.date': 'तिथि',
  'history.in': 'इन',
  'history.out': 'आउट',
  'history.duration': 'अवधि',
  'history.site': 'साइट',
  'history.tasks': 'कार्य',
  'history.inProgress': 'प्रगति में',
  'history.remote': 'Remote',

  'holidays.subtitle': 'राष्ट्रीय और कंपनी छुट्टियाँ।',
  'holidays.error': 'छुट्टियाँ लोड नहीं हो सकीं।',
  'holidays.national': 'राष्ट्रीय छुट्टियाँ',
  'holidays.company': 'कंपनी छुट्टियाँ',
  'holidays.upcoming': 'आगामी',
  'holidays.empty': 'कोई छुट्टी सूचीबद्ध नहीं।',

  'announcements.subtitle': 'HR से कंपनी-व्यापी अपडेट।',
  'announcements.error': 'घोषणाएँ लोड नहीं हो सकीं।',
  'announcements.empty': 'अभी कोई घोषणा नहीं।',
  'announcements.authorFallback': 'HR',

  'policy.error': 'यह नीति लोड नहीं हो सकी।',

  'leave.hint.endBeforeStart': 'समाप्ति तिथि प्रारंभ तिथि के बाद या समान होनी चाहिए।',
  'leave.hint.startTooPast': 'प्रारंभ तिथि 7 दिन से अधिक पुरानी नहीं हो सकती।',
  'leave.hint.startTooFuture': 'प्रारंभ तिथि 1 वर्ष से अधिक आगे नहीं हो सकती।',
  'leave.hint.tooLong': 'छुट्टी अनुरोध 30 दिन से अधिक नहीं हो सकते।'
};

export default hi;
